import { Inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../constants/constants';
import { CommonDataService } from '../../services/common-data.service';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'multilingualCurrency',
  standalone: true,
  pure: false
})
export class MultilingualCurrencyPipe implements PipeTransform {

  constructor(
    private readonly translateService: TranslateService,
    private readonly commonDataService: CommonDataService
  ) {}

  transform(value: number | string): string {
    const decimalPrecision = this.commonDataService.getDecimalPrecision();
    if (value === null || value === undefined || value === Constants.EMPTY_STRING) {
      return Constants.EMPTY_STRING;
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) {
      return value.toString();
    }

    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || Constants.LANGUAGE_EN_US;

    try {
      if (currentLang === Constants.LANGUAGE_FR_CA) {
        return this.formatFrenchCanadian(numericValue, decimalPrecision);
      } else {
        return this.formatEnglish(numericValue, decimalPrecision);
      }
    } catch (error) {
      return `${Constants.DOLLAR}${numericValue.toFixed(decimalPrecision)}`;
    }
  }

  private formatEnglish(value: number, decimalPrecision: number): string {
    return new Intl.NumberFormat(Constants.LANGUAGE_EN_US, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPrecision,
      maximumFractionDigits: decimalPrecision
    }).format(value);
  }

  private formatFrenchCanadian(value: number, decimalPrecision: number): string {
    const absoluteValue = Math.abs(value);
    const isNegative = value < Constants.ZERO;

    const fixedValue = absoluteValue.toFixed(decimalPrecision);
    const [integerPart, decimalPart] = fixedValue.split(Constants.DOT);

    const formattedInteger = this.addSpaceSeparators(integerPart);

    const formatted = `${formattedInteger},${decimalPart} ${Constants.DOLLAR}`;

    return isNegative ? `-${formatted}` : formatted;
  }

  private addSpaceSeparators(numberStr: string): string {
    return numberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
